import { styled } from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  billingHistoryAgGridStyle: 'billingHistoryAgGridStyle',
  accountInfoBillingInfoFirstGrid: 'accountInfoBillingInfoFirstGrid',
  accountInfoBillingInfoSecondGrid: 'accountInfoBillingInfoSecondGrid',
  SecondGridBox: 'SecondGridBox',
  SearchField: 'SearchField',
  TagButton: 'TagButton',
  UploadIcon: 'UploadIcon',
  PopOverBox: 'PopOverBox',
  CreatePopOverButton: 'CreatePopOverButton',
  TabSectionHeaderGrid1: 'TabSectionHeaderGrid1',
  HorizontalLine: 'HorizontalLine',
  changePasswordButton: 'changePasswordButton',
  editDetailsButton: 'editDetailsButton',
  billingInfoFirstGridBoxes: 'billingInfoFirstGridBoxes',
  billingInfoSecondGridBoxes: 'billingInfoSecondGridBoxes',
  tabs: 'tabs',
  avatar: 'avatar',
  AdminProfilePicture: 'AdminProfilePicture',
  SubscriptionAmount: 'SubscriptionAmount',
  gridItemMainTitle: 'gridItemMainTitle',
  subscriptionDetailBox: 'subscriptionDetailBox',
  emailBox: 'emailBox',
  emailBoxMember: 'emailBoxMember',
  userNameBox: 'userNameBox',
  organizationNameBox: 'organizationNameBox',
  addressAndPlanDetailBox: 'addressAndPlanDetailBox',
  planExpiryDate: 'planExpiryDate',
  paymentDetailBox: 'paymentDetailBox',
  userDetailBox: 'userDetailBox',
  GridRightLink: 'GridRightLink',
  GridTitleBoarderBottom: 'GridTitleBoarderBottom',
  secondGridTitleBoarderBottom: 'secondGridTitleBoarderBottom',
  AdminAddress: 'AdminAddress',
  gridHeader: 'gridHeader',
  donutChartBox: 'donutChartBox',
  changePasswordBackdrop: 'changePasswordBackdrop',
  planDetailBox: 'planDetailBox',
  planDetailAndPaymentInfo: 'planDetailAndPaymentInfo',
  loaderBox: 'loaderBox',
  remainingCreditsTypography: 'remainingCreditsTypography',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    [up('xs')]: {
      height: '83vh',
    },
    [up('sm')]: {
      height: '68vh',
    },
    [up('md')]: {
      height: '65vh',
    },
    [up('lg')]: {
      height: '68vh',
    },
    [up('xl')]: {
      height: '75vh',
    },
    [up('xxl')]: {
      height: '78vh',
    },
    overflow: 'auto',

    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
  },

  [`& .${classes.billingHistoryAgGridStyle}`]: {
    [up('xs')]: {
      height: '35vh',
    },
    [up('sm')]: {
      height: '35vh',
    },
    [up('md')]: {
      height: '35vh',
    },
    [up('lg')]: {
      height: '40vh',
    },
    [up('xl')]: {
      height: '45vh',
    },
    [up('xxl')]: {
      height: '50vh',
    },
  },
  [`& .${classes.accountInfoBillingInfoFirstGrid}`]: {
    columnGap: '1.145vw',
    marginTop: '2vh',
    paddingLeft: '1.5vw',
    paddingRight: '1.5vw',
    justifyContent: 'space-between',
  },
  [`& .${classes.planDetailBox}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    [up('xs')]: { padding: '8px 8px' },
    [up('sm')]: { padding: '8px 10px' },
    [up('md')]: { padding: '8px 16px' },
    [up('lg')]: { padding: '8px 20px' },
    [up('xl')]: { padding: '8px 24px' },
    [up('xxl')]: { padding: '8px 34px' },
  },
  [`& .${classes.changePasswordBackdrop}`]: {
    color: theme.palette.secondaryWhite.main,
    zIndex: theme.zIndex.drawer + 1,
  },
  [`& .${classes.donutChartBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '7px',
    margin: 'auto',
    [up('xs')]: {
      width: '60px',
      height: '60px',
    },
    [up('sm')]: {
      width: '80px',
      height: '65px',
    },
    [up('md')]: {
      width: '93px',
      height: '85px',
    },
    [up('lg')]: {
      width: '205px',
      height: '100px',
    },
    [up('xl')]: {
      width: '258px',
      height: '110px',
    },
    [up('xxl')]: {
      width: '393px',
      height: '125px',
    },
  },
  [`& .${classes.remainingCreditsTypography}`]: {
    textAlign: 'center',
  },
  [`& .${classes.gridHeader}`]: {
    margin: '4.037vh 1.5vw',
  },
  [`& .${classes.planDetailAndPaymentInfo}`]: {
    [up('md')]: {
      width: '22vw',
    },
    [up('lg')]: {
      width: '19vw',
    },
    [up('xl')]: {
      width: '18vw',
    },
    [up('xxl')]: {
      width: '20vw',
    },
  },
  [`& .${classes.accountInfoBillingInfoSecondGrid}`]: {
    columnGap: '1.145vw',
    marginTop: '2.037vh',
    paddingLeft: '1.5vw',
    paddingRight: '1.5vw',
    justifyContent: 'space-between',
  },
  [`& .${classes.SecondGridBox}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.changePasswordButton}`]: {
    cursor: 'pointer',
    color: theme.palette.darkPurple.main,
    height: '20px',
    width: '20px',
  },
  [`& .${classes.editDetailsButton}`]: {
    cursor: 'pointer',
  },
  [`& .${classes.billingInfoFirstGridBoxes}`]: {
    columnGap: '1.145vw',
    marginTop: '2vh',
    borderRadius: '5px',
    boxShadow: `0px 0px 20px 5px ${theme.palette.secondaryBlack.lightest}`,
    backgroundColor: theme.palette.secondaryWhite.main,
    minHeight: '80px',
    // [up('xs')]: {
    //   height: '35px',
    // },
    // [up('sm')]: {
    //   height: '47px',
    // },
    // [up('md')]: {
    //   height: '70px',
    // },
    // [up('lg')]: {
    //   height: '93px',
    // },
    // [up('xl')]: {
    //   height: '109px',
    // },
    // [up('xxl')]: {
    //   height: '133px',
    // },
  },
  [`& .${classes.billingInfoSecondGridBoxes}`]: {
    columnGap: '1.145vw',
    marginTop: '2vh',
    minHeight: '150px',
    borderRadius: '5px',
    boxShadow: `0px 0px 20px 5px ${theme.palette.secondaryBlack.lightest}`,
    backgroundColor: theme.palette.secondaryWhite.main,
    // [up('xs')]: {
    //   height: '81px',
    // },
    // [up('sm')]: {
    //   height: '145px',
    // },
    // [up('md')]: {
    //   height: '162px',
    // },
    // [up('lg')]: {
    //   height: '189px',
    // },
    // [up('xl')]: {
    //   height: '230px',
    // },
    // [up('xxl')]: {
    //   height: '260px',
    // },
  },
  [`& .${classes.HorizontalLine}`]: {
    borderBottom: '1px solid rgba(43, 30, 89, 0.2)',
    paddingBottom: '1.5vh',
  },
  [`& .${classes.gridItemMainTitle}`]: {
    color: theme.palette.darkPurple.main,
    noWrap: true,
  },
  [`& .${classes.GridTitleBoarderBottom}`]: {
    display: 'flex',
    height: '40px',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.darkPurple.lighter}`,
    [up('xs')]: { padding: '8px 8px' },
    [up('sm')]: { padding: '8px 10px' },
    [up('md')]: { padding: '8px 16px' },
    [up('lg')]: { padding: '8px 20px' },
    [up('xl')]: { padding: '8px 24px' },
    [up('xxl')]: { padding: '8px 34px' },
  },
  [`& .${classes.secondGridTitleBoarderBottom}`]: {
    display: 'flex',
    height: '40px',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.darkPurple.lighter}`,
    [up('xs')]: { padding: '8px 8px' },
    [up('sm')]: { padding: '8px 10px' },
    [up('md')]: { padding: '8px 16px' },
    [up('lg')]: { padding: '8px 20px' },
    [up('xl')]: { padding: '8px 24px' },
    [up('xxl')]: { padding: '8px 34px' },
  },
  [`& .${classes.userNameBox}`]: {
    paddingTop: '2.5vh',
    marginLeft: '0.72vw',
  },
  [`& .${classes.organizationNameBox}`]: {
    marginTop: '0.292vh',
    marginLeft: '0.72vw',
  },
  [`& .${classes.subscriptionDetailBox}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [up('xs')]: { padding: '8px 8px' },
    [up('sm')]: { padding: '8px 10px' },
    [up('md')]: { padding: '8px 16px' },
    [up('lg')]: { padding: '8px 20px' },
    [up('xl')]: { padding: '8px 24px' },
    [up('xxl')]: { padding: '8px 34px' },
  },
  [`& .${classes.emailBoxMember}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [up('xs')]: { padding: '3px 7px' },
    [up('sm')]: { padding: '4px 10px' },
    [up('md')]: { padding: '10px 16px' },
    [up('lg')]: { padding: '15px 20px' },
    [up('xl')]: { padding: '18px 24px' },
    [up('xxl')]: { padding: '20px 34px' },
  },
  // ...... BillingInfo........
  [`& .${classes.emailBox}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  [`& .${classes.userDetailBox}`]: {
    display: 'flex',
  },
  [`& .${classes.addressAndPlanDetailBox}`]: {
    // height: '76%',
    // overflow: 'hidden',
    // padding: '8px 8px',
  },
  [`& .${classes.planExpiryDate}`]: {
    // paddingLeft: '2.1875vw',
    // paddingTop: '1.203vh',
  },
  [`& .${classes.paymentDetailBox}`]: {
    // paddingTop: '2.777vh',
  },
  [`& .${classes.GridRightLink}`]: {
    paddingTop: '1.76vh',
    marginRight: '2vw',
  },
  [`& .${classes.AdminAddress}`]: {
    paddingTop: '1vh',
    marginLeft: '1.770vw',
    [up('xs')]: {
      width: '36.4vw',
    },
    [up('sm')]: {
      width: '34.4vw',
    },
    [up('md')]: {
      width: '28.4vw',
    },
    [up('lg')]: {
      width: '17.4vw',
      marginRight: '17.44vw',
    },
    [up('xl')]: {
      width: '19.4vw',
    },
    [up('xxl')]: {
      width: '17.4vw',
      marginRight: '17.44vw',
    },
  },
  [`& .${classes.avatar}`]: {
    backgroundColor: theme.palette.primary.main,
    marginTop: '2.777vh',
    marginLeft: '1.770vw',
    [up('xs')]: {
      height: '30px',
      width: '30px',
    },
    [up('md')]: {
      height: '40px',
      width: '40px',
    },
    [up('lg')]: {
      height: '45px',
      width: '45px',
    },
  },
  [`& .${classes.AdminProfilePicture}`]: {
    marginTop: '2.777vh',
    marginLeft: '1.770vw',
    [up('xs')]: {
      width: '24px',
      height: '24px',
    },
    [up('sm')]: {
      width: '26px',
      height: '26px',
    },
    [up('md')]: {
      width: '28px',
      height: '28px',
    },
    [up('lg')]: {
      width: '31px',
      height: '31px',
    },
    [up('xl')]: {
      width: '38px',
      height: '38px',
    },
    [up('xxl')]: {
      width: '45px',
      height: '45px',
    },
  },
  [`& .${classes.SearchField}`]: {
    marginRight: '1vw',
    '& .MuiInputBase-input': {
      [up('xs')]: {
        width: '155px',
        height: '8px',
      },
      [up('sm')]: {
        width: '100px',
        height: '13px',
      },
      [up('md')]: {
        width: '125px',
        height: '13px',
      },
      [up('lg')]: {
        width: '145px',
        height: '18px',
      },
      [up('xl')]: {
        width: '185px',
        height: '23px',
      },
      [up('xxl')]: {
        width: '210px',
        height: '29px',
      },
    },
  },
  [`& .${classes.TagButton}`]: {
    marginRight: '1vw',
    background: theme.palette.dynamicBlack.lightest,
    color: theme.palette.shoeWax.main,
    ':hover': {
      background: theme.palette.dynamicBlack.lightest,
      color: theme.palette.shoeWax.main,
    },
    [up('xs')]: {
      width: '70px',
      height: '27px',
    },
    [up('sm')]: {
      width: '70px',
      height: '32px',
    },
    [up('md')]: {
      width: '70px',
      height: '32px',
    },
    [up('lg')]: {
      width: '80px',
      height: '37px',
    },
    [up('xl')]: {
      width: '100px',
      height: '43px',
    },
    [up('xxl')]: {
      width: '108px',
      height: '48px',
    },
  },
  [`& .${classes.UploadIcon}`]: {
    [up('xs')]: {
      width: '13px',
      height: '12px',
    },
    [up('sm')]: {
      width: '13px',
      height: '12px',
    },
    [up('md')]: {
      width: '13px',
      height: '13px',
    },
    [up('lg')]: {
      width: '15px',
      height: '15px',
    },
    [up('xl')]: {
      width: '16px',
      height: '16px',
    },
    [up('xxl')]: {
      width: '18px',
      height: '18px',
    },
  },
  [`& .${classes.PopOverBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    width: '18vw',
  },
  [`& .${classes.CreatePopOverButton}`]: {
    backgroundColor: theme.palette.dynamicBlack.lightest,
  },

  [`& .${classes.tabs}`]: {
    fontFamily: 'Heebo',
    fontWeight: 400,
    textTransform: 'none',
    [up('xs')]: {
      padding: '18px 14px',
    },
    [up('sm')]: {
      padding: '8px 14px',
    },
    [up('md')]: {
      padding: '10px 18px',
    },
    [up('lg')]: {
      padding: '12px 22px',
    },
    [up('xl')]: {
      padding: '14px 26px',
    },
    [up('xxl')]: {
      padding: '16px 30px',
    },
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      height: '60vh',
    },
    [up('sm')]: {
      height: '70vh',
    },
    [up('md')]: {
      height: '60vh',
    },
    [up('lg')]: {
      height: '65vh',
    },
    [up('xl')]: {
      height: '70vh',
    },
    [up('xxl')]: {
      height: '80vh',
    },
  },
}));
